export function getMenuItemState(id, menuItemsState) {
  if (!menuItemsState.menuItems[id]) return {
    id: undefined,
    tabIndex: undefined,
    isFocused: false,
    visuallyHidden: false
  };
  return menuItemsState.menuItems[id];
}